import { useState, useEffect } from 'react'
import _ from 'common-tools/LodashHelper'

export function useParseOnClick (onClick, sendToURL, addLayoutContentBreadCrumbKey) {
  const [onClickFunction, setOnClickFunction] = useState({ func: undefined })

  useEffect(() => {
    let func = null

    if (_.isFunction(onClick)) {
      func = onClick
    } else if (_.isString(onClick)) {
      func = () => {
        sendToURL(onClick)
      }
    } else if (_.isPlainObject(onClick)) {
      func = () => {
        sendToURL(onClick.url)
        if (onClick.breadCrumbKey) {
          addLayoutContentBreadCrumbKey(onClick.breadCrumbKey.key, onClick.breadCrumbKey.value)
        }
      }
    }
    setOnClickFunction({ func: func })
  }, [onClick])

  return [onClickFunction]
}

export default useParseOnClick
